import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { MatTooltip } from '@angular/material/tooltip'
import { MatSelectModule } from '@angular/material/select'
import { MatOption } from '@angular/material/core'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import moment from 'moment'
import { SearchAgendaComprasOsModel } from '../../../core/models/reserva-compras.model'
import { ServiceOrderStatusService } from '../../../core/services/service/service-order-status/service-order-status.service'

@Component({
  selector: 'form-search-reserva-os',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatSelectModule,
    MatOption,
  ],
  templateUrl: './form-search-reserva-os.component.html',
  styleUrl: './form-search-reserva-os.component.scss',
})
export class FormSearchReservaOsComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private serviceOrderStatusService: ServiceOrderStatusService,
  ) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search = ''

  statusOsList: any[] = []

  ngOnInit() {
    this.createForm()
    this.getStatusOsList()
  }

  getStatusOsList() {
    this.serviceOrderStatusService.listServiceOrderStatus().subscribe({
      next: (response: any) => {
        this.statusOsList = response.data ?? []
      },
      error: () => {
        this.statusOsList = []
      },
    })
  }

  ngOnChanges() {}

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      tgCode: [''],
      osCode: [''],
      client: [''],
      origin: [''],
      destination: [''],
      service: [''],
      vehicleType: [''],
      driverType: [''],
      dateStart: [''],
      dateEnd: [''],
      statusOsId: [''],
    })
  }

  sendSearch(search = true) {
    if (search && this.checkSearch()) {
      const searchModel = new SearchAgendaComprasOsModel()
      searchModel.codigoTg = this.toNullable(this.formSearch.get('tgCode')!.value)
      searchModel.codigoOs = this.toNullable(this.formSearch.get('osCode')!.value)
      searchModel.nomeCliente = this.toNullable(
        this.formSearch.get('client')!.value,
      )
      searchModel.descricaoOrigem = this.toNullable(
        this.formSearch.get('origin')!.value,
      )
      searchModel.descricaoDestino = this.toNullable(
        this.formSearch.get('destination')!.value,
      )
      searchModel.servico = this.toNullable(this.formSearch.get('service')!.value)
      searchModel.descricaoTipoVeiculo = this.toNullable(
        this.formSearch.get('vehicleType')!.value,
      )
      searchModel.descricaoTipoMotorista = this.toNullable(
        this.formSearch.get('driverType')!.value,
      )
      searchModel.dataInicio = this.formSearch.get('dateStart')!.value
        ? moment(this.formSearch.get('dateStart')!.value).format('DD/MM/YYYY')
        : null
      searchModel.dataFinal = this.formSearch.get('dateEnd')!.value
        ? moment(this.formSearch.get('dateEnd')!.value).format('DD/MM/YYYY')
        : null
      searchModel.statusOsId = this.toNullableNumber(
        this.formSearch.get('statusOsId')!.value,
      )
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.reset({
        tgCode: '',
        osCode: '',
        client: '',
        origin: '',
        destination: '',
        service: '',
        vehicleType: '',
        driverType: '',
        dateStart: '',
        dateEnd: '',
        statusOsId: '',
      })

      this.responseSearch.emit({ search: search, model: {} })
    }
  }

  private toNullable(value: string): string | null {
    return value && value.trim().length > 0 ? value : null
  }

  private toNullableNumber(value: any): number | null {
    return value !== null && value !== undefined && value !== ''
      ? value
      : null
  }

  checkSearch() {
    const fields = [
      'tgCode',
      'osCode',
      'client',
      'origin',
      'destination',
      'service',
      'vehicleType',
      'driverType',
    ]
    if (fields.some((f) => this.formSearch.get(f)!.value.trim().length > 0)) {
      return true
    }
    if (
      this.formSearch.get('dateStart')!.value ||
      this.formSearch.get('dateEnd')!.value
    ) {
      return true
    }
    if (this.formSearch.get('statusOsId')!.value) {
      return true
    }
    return false
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }
}
